import { render, staticRenderFns } from "./PendingPqp.vue?vue&type=template&id=2df78102"
import script from "./PendingPqp.vue?vue&type=script&lang=js"
export * from "./PendingPqp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports